import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { fetchEvaluationGroupById } from "@/lib/api/resources/evaluationGroups";
import { EvaluationGroupDetailCard } from "./components/EvaluationGroupDetailCard";

export const EvaluationGroupDetail = () => {
  const { id } = useParams();

  if (!id) return null;

  const evaluationGroupQuery = useQuery({
    queryKey: ["evaluation-group", id],
    queryFn: () => fetchEvaluationGroupById(id),
  });

  return (
    <div>
      <EvaluationGroupDetailCard
        evaluationGroup={evaluationGroupQuery.data}
        isLoading={evaluationGroupQuery.isLoading}
      />
    </div>
  );
};
